import { Calendar } from 'primereact/calendar';
import { addLocale } from 'primereact/api';

const BaseCalendar = (props)=>{
    return <Calendar {...props}></Calendar>
}

const baseApiAddLocale = addLocale;
export default BaseCalendar;
export {baseApiAddLocale}